import React, { useState, useEffect } from "react";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

// Images
import bgImage from "assets/images/intro/slide/bg-contents-one.jpeg";
import bgImage2 from "assets/images/intro/slide/noah-buscher-x8ZStukS2PM-unsplash.jpg";
import bgImage3 from "assets/images/intro/slide/bg-sign-in-basic.jpeg";

const contents = [
  {
    id: 1,
    title: "전력 소비 절감, 환경 보호의 시작.",
    subtitle: "Reducing Power Consumption, the Start of Environmental Protection.",
    backgroundImage: bgImage,
  },
  {
    id: 2,
    title: "지구를 살리는 에너지 절약, 우리의 에너지 솔루션.",
    subtitle: "Energy Savings to Save the Planet, Our Energy Solution.",
    backgroundImage: bgImage2,
  },
  {
    id: 3,
    title: "좋은빛은 고객님의 공간을 더욱 아름답게, 에너지 절약을 통해 환경 보호에도 기여합니다.",
    subtitle: '"혁신적인 기술로 만들어진 JOHEUNBICH (좋은빛)의 조명으로 공간을 새롭게 꾸며보세요."',
    backgroundImage: bgImage3,
  },
];

function SlideContents() {
  const [currentSlide, setCurrentSlide] = useState(0);

  // 슬라이드 자동 변경
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % contents.length); // 순환 방식
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <MKBox minHeight="50vh" width="100%" position="relative" overflow="hidden">
      {contents.map((slide, index) => (
        <MKBox
          key={slide.id}
          minHeight="50vh"
          width="100%"
          sx={{
            backgroundImage: `url(${slide.backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "top",
            position: "absolute",
            top: 0,
            left: 0,
            opacity: index === currentSlide ? 1 : 0,
            transform: index === currentSlide ? "scale(1)" : "scale(0.8)",
            transition: "opacity 1s ease, transform 1s ease", // 줌 효과
            zIndex: index === currentSlide ? 1 : 0,
          }}
        >
          <Container>
            <Grid container item xs={18} lg={12} mt={10} justifyContent="center" mx="auto">
              {slide.id === 3 ? (
                <MKTypography
                  variant="h3"
                  color="white"
                  mt={8}
                  mb={1}
                  sx={({ breakpoints, typography: { size } }) => ({
                    [breakpoints.down("md")]: {
                      fontSize: size["lg"],
                    },
                  })}
                >
                  {slide.title}
                </MKTypography>
              ) : (
                <MKTypography
                  variant="h1"
                  color="white"
                  mt={8}
                  mb={1}
                  sx={({ breakpoints, typography: { size } }) => ({
                    [breakpoints.down("md")]: {
                      fontSize: size["lg"],
                    },
                  })}
                >
                  {slide.title}
                </MKTypography>
              )}
              {slide.subtitle && (
                <MKTypography
                  variant="body1"
                  color="white"
                  textAlign="center"
                  px={{ xs: 6, lg: 15 }}
                  mt={5}
                >
                  {slide.subtitle}
                </MKTypography>
              )}
            </Grid>
          </Container>
        </MKBox>
      ))}
    </MKBox>
  );
}

export default SlideContents;
